import { Component, ElementRef, Input, Output, EventEmitter, OnInit, AfterContentChecked } from '@angular/core';
import {NgStyle} from '@angular/common';

import { EventsService } from '../../shared/Events.service';
import { ElectionService } from '../../shared/election-service/election.service';
import { SettingsService } from '../../shared/settings/settings.service';
import { TranslateService} from 'ng2-translate/ng2-translate';

import GeometryService = require('esri/tasks/GeometryService');
import ProjectParameters = require('esri/tasks/support/ProjectParameters');
import SpatialReference = require('esri/geometry/SpatialReference');
import Point = require('esri/geometry/Point');

import {Config} from '../../config';

import Utilities from '../../utilities';

declare let componentHandler: any;


type votingLocationType = "polling-place" | "early-voting";

@Component({
    selector: 'polling-place-info',
    template: require('./pollingplace.component.html')
})

export class PollingPlaceComponent implements OnInit, AfterContentChecked  {
 
    //Address variables
     selectedFullAddress:string;
     selectedAddressLocationString:string;
     selectedAddressLocation:Object;

    //Polling place location variabels
     pollingPlaceName: string;
     pollingPlacePrecinct: string;
     pollingPlaceAddress: string;
     pollingPlaceCity: string;
     photos:Array<string>;
     activePhoto:string;

    //early voting location variables
     satelliteName: string;
     satelliteAddress: string;
     satelliteCity: string;
     satelliteSchedule: string;
     satelliteLocations: Array<Object>;

     //General state/admin variables
     isPollingPlaceRetrieved:boolean = false;
     isEarlyVotingRetrieved:boolean = false;
     isRedirectEnabled:boolean = true;
     isAutomaticRedirectionEnabled:boolean = false;
     tabActivated:boolean = false;
     error: any;
     activeTab:boolean;
     appSettings: Object;
     redirectHTMLComponent:string;

     //email
     toAddress:string;
     fromAddress:string; 
     emailSubject:string;
     emailBody:string;
     message:Object;
     showEmailPanel:boolean = false;

    private pollingPlaceInfo: Object;
    private selectedAddressSuggestion:Object;

    constructor(private elRef: ElementRef, private _eventsService: EventsService, public _electionService: ElectionService, private _settingsService: SettingsService, private _translate: TranslateService) { 
        let urlQueryObject:any = {};
        for(var prop in dojo["queryToObject"](window.location.search.substring(1))){
            let propValue:string = dojo["queryToObject"](window.location.search.substring(1))[prop];
            let propCorr:string = prop.toLowerCase();
            urlQueryObject[propCorr] = propValue;
        }
        if(urlQueryObject.tab){
            let selectTab:string = urlQueryObject.tab;
            if (selectTab.toLowerCase() == "tabpollingplace"){
                this.isAutomaticRedirectionEnabled = true;
            }
        }                
    }

    ngOnInit () {

        
        //subscribe to the selected address from the address search
            this._eventsService.selectedAddressObject$.subscribe(address => {
                //get the current address
                    this.selectedAddressSuggestion = address["addressSuggestion"];

                    //Get the current address location
                    this.selectedAddressLocation = address["addressLocation"];  

                }
            ); 
    
            //subscribe to the search invoked event, once a search is begun
            this._eventsService.searchInvoked$.subscribe(
                address => {
                    //get the current address
                    this.selectedAddressSuggestion = address["addressSuggestion"];
    
                    //Get the current address location
                    this.selectedAddressLocation = address["addressLocation"];  
                    this.isPollingPlaceRetrieved = false;

                    this.selectedAddressLocation ? this.preGetPollingPlaceInformation() : console.log("Address location is undefined");

                }

            );

            
            // Get app settings from settings service 
            this.appSettings = Config.config[0];
            let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'PollingPlace'; });
            this.tabActivated = currentTabSettings[0].activate;  

            // this._settingsService.getAppSettings().subscribe(
            //     settings => { 
            //         this.appSettings = settings[0];
            //         let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'PollingPlace'; });
            //         this.tabActivated = currentTabSettings[0].activate;                
            //         // this.electionServiceURL = this.appSettings["electionServiceURL"];
            //     },
            //     err => { this.error = true }
            // );
                // componentHandler.upgradeAllRegistered();
        }
        //Upon component initialize, wire up event subscribers
        ngAfterContentChecked() {

            // componentHandler.upgradeAllRegistered();
        
        }


 
        // destroy map
        ngOnDestroy() {

        }
    
        // Pre-step for polling location search - get lat lon if the redirect to indyvotes.org is enabled
        preGetPollingPlaceInformation(){
            if(this.isRedirectEnabled){
                var pt:Point = new Point({
                    x:this.selectedAddressLocation["X"],
                    y:this.selectedAddressLocation["Y"],
                    spatialReference:{
                        "wkid":2965
                    }
                });
                var gsvc:GeometryService = new GeometryService();
                gsvc.url = this.appSettings["geometryService"]["url"];
                var params:ProjectParameters = new ProjectParameters();
                params.geometries = [pt];
                params.outSR = new SpatialReference({
                    "wkid":4326
                });
                gsvc.project(params).then(projectedGeometries => {
                    this.selectedAddressLocationString = "lat=" + projectedGeometries[0]["y"] + "&lng=" + projectedGeometries[0]["x"];
                    var automaticRedirectURL:string = "";
                    this._translate.get("pollingPlaceRedirectURL").subscribe(text => automaticRedirectURL = text );
                    automaticRedirectURL = automaticRedirectURL.replace("{0}", this.selectedAddressLocationString);
                    console.log(automaticRedirectURL);
                    if(this.isAutomaticRedirectionEnabled == true){
                        window.open(automaticRedirectURL, "_self");
                    }else{
                        this._translate.get("pollingPlaceRedirect").subscribe(text => this.redirectHTMLComponent = text );
                        this.redirectHTMLComponent = this.redirectHTMLComponent.replace("{0}", automaticRedirectURL);
                        this.isPollingPlaceRetrieved = true;
                        this.getPollingPlaceInformation();
                    }                    
                }, error => {
                    this.error = error;
                    console.log("Logging error: Cannot retrieve Polling Place. " + this.error );
                });
            }else{
                this.getPollingPlaceInformation()
            }
        }


//Retrieve the polling place info from the service
    getPollingPlaceInformation() {

         this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion["FullAddress"] : this.selectedFullAddress = "Address undefined";

        //Get primary polling place info
         this._electionService
            .getPollLocation(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
            .then(pollingplace => {
                this.pollingPlaceInfo = pollingplace
                this.pollingPlaceName = pollingplace.Name
                this.photos = pollingplace.Photos
                this.pollingPlacePrecinct = pollingplace.Precinct;
                this.pollingPlaceAddress = pollingplace.StreetAddress
                this.pollingPlaceCity = pollingplace.City

                this.isPollingPlaceRetrieved = true
                this._eventsService.setPollingPlace(pollingplace)

                }

            )
            .catch(error => {
                
                this.error = error;
                console.log("Logging error: Cannot retrieve Polling Place. " + this.error );

            });

        // //get the early votiung location info
        //  this._electionService
        //     .getSatellites(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
        //     .then(satellites => {
        //          this.satelliteLocations = satellites
        //          this.satelliteName = satellites[0].Name
                 
        //          this.isEarlyVotingRetrieved = true

        //          this._eventsService.setSatellites(satellites)
                
        //         }
        //     )
        //     .catch(error => {
                
        //         this.error = error
        //         console.log("Logging error: Cannot retrieve Satellite Polling Place. " + this.error )
        //      });
        

        
    }

    //activate map panel and zoom to the polling place
    viewPollingPlaceOnMap () {
        
        this._eventsService.zoomToLocation({"place": this.pollingPlaceInfo, "id":"polling"});
        this._eventsService.setActiveTab("tabMap");
    
        
    }

    //activate map panel and zoom to the polling place
    viewSatelliteOnMap (satelliteVotingLocation:Object) {

        this._eventsService.zoomToLocation(satelliteVotingLocation);
        this._eventsService.setActiveTab("tabMap");
 
    }

    //activate map panel and zoom to the polling place
    getDrivingDirections (destination:string = "polling") {
        this._eventsService.getDirections(destination);
        this._eventsService.setActiveTab("tabMap");
    }
    //view the full image in the larger modal dialog
    viewFullImage (photoURL:string) {
        let modalImg = document.getElementById("img01");
        let modal = document.getElementById('myModal');
        modal.style.display = "block";
        this.activePhoto = photoURL;

    }

    //show/hide the share via email panel
    toggleEmailPanel (display:boolean, votingType:votingLocationType, satelliteVotingLocation:Object) {

        this.showEmailPanel = display;

        switch (votingType) {

            case "polling-place":
                this.showEmailPanel ? this.sharePollingPlace(): null;
                break;
            case "early-voting":
                this.showEmailPanel && satelliteVotingLocation ? this.shareSatellitePollingPlace(satelliteVotingLocation): null;
                break;
        }
        
        
        // this.showEmailPanel ? this.sharePollingPlace(): null;

    }

    //trigger the sharing of a polling place via email
    sharePollingPlace() {

        let forAddress:string;
        let ppPrecinctLabel:string;
        let ppNameLabel:string;
        let ppAddressLabel:string;
        let ppCityLabel:string;
        let accessibilityText:string 


        this._translate.get("emailSubject").subscribe(text => this.emailSubject = text );
        this._translate.get("emailForAddress").subscribe(text => forAddress = text );
        this._translate.get("pplAddress").subscribe(text => ppAddressLabel = text );
        this._translate.get("pplPrecinct").subscribe(text => ppPrecinctLabel = text );
        this._translate.get("pplPollingPlace").subscribe(text => ppNameLabel = text );
        this._translate.get("pplCity").subscribe(text => ppCityLabel = text );
        this._translate.get("accessibilityText").subscribe(text => accessibilityText = text );

        // let accessibilityText:string = "Polling locations have been set for the May 3, 2016 General Election. Occasionally locations have to be changed for unforseen reasons so please check back.";

        this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
                            ppPrecinctLabel + " " + this.pollingPlacePrecinct + "<br/>" +
                            ppNameLabel + ' ' + this.pollingPlaceName + "<br/>" +
                            ppAddressLabel + " " + this.pollingPlaceAddress +
                            "<br/>" + ppCityLabel + " " + this.pollingPlaceCity + "<br/><br/>" +
                            accessibilityText;

        
    }

    //trigger the sharing of a polling place via email
    shareSatellitePollingPlace(satelliteVotingLocation:Object) {


        // this.showEmailPanel = true;

        let forAddress:string;
        let pplHoursLabel:string;
        let ppNameLabel:string;
        let ppAddressLabel:string;
        let ppCityLabel:string;
        let accessibilityText:string 


        this._translate.get("pplTitle").subscribe(text => this.emailSubject = text );
        this._translate.get("emailForAddress").subscribe(text => forAddress = text );
        this._translate.get("pplAddress").subscribe(text => ppAddressLabel = text );
        this._translate.get("pplHours").subscribe(text => pplHoursLabel = text );
        this._translate.get("pplPollingPlace").subscribe(text => ppNameLabel = text );
        this._translate.get("pplCity").subscribe(text => ppCityLabel = text );
        // this._translate.get("accessibilityText").subscribe(text => accessibilityText = text );
        this.emailSubject = "Early Voting Locations";
       
        // let accessibilityText:string = "Polling locations have been set for the May 3, 2016 General Election. Occasionally locations have to be changed for unforseen reasons so please check back.";

        // this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
        //                     ppPrecinctLabel + " " + this.pollingPlacePrecinct + "<br/>" +
        //                     ppNameLabel + ' ' + this.pollingPlaceName + "<br/>" +
        //                     ppAddressLabel + " " + this.pollingPlaceAddress +
        //                     "<br/>" + ppCityLabel + " " + this.pollingPlaceCity + "<br/><br/>" +
        //                     accessibilityText;

        this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
                            satelliteVotingLocation["Name"] + "<br/><br/>" + ppAddressLabel + " " + satelliteVotingLocation["StreetAddress"] +
                            "<br/>" + ppCityLabel + " " + satelliteVotingLocation["City"] + "<br/>" + pplHoursLabel +
                           satelliteVotingLocation["Schedule"];


    }



}


// WEBPACK FOOTER //
// ./app/information/pollingplace/pollingplace.component.ts